import { useEffect } from "react";

const setMeta = (name, content, attr = "name") => {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const BASE_URL = "https://www.priyajitsystems.in";

export const useSeo = ({ title, description, image, keywords, jsonLd }) => {
  useEffect(() => {
    if (title) document.title = title;
    setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:site_name", "Priyajit Systems", "property");
    setMeta("og:url", BASE_URL + window.location.pathname, "property");
    if (image) setMeta("og:image", BASE_URL + image, "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", BASE_URL + window.location.pathname);

    const prev = document.getElementById("page-jsonld");
    if (prev) prev.remove();
    if (jsonLd) {
      const script = document.createElement("script");
      script.id = "page-jsonld";
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    window.scrollTo(0, 0);
  }, [title, description, image, keywords, jsonLd]);
};
